import React from "react";
import { FaFileInvoiceDollar, FaDollarSign, FaRegClock } from "react-icons/fa";
import classes from "./Section6.module.css";
import { Link } from "react-router-dom";

export default function Section6() {
  return (
    <section className={classes.section6Wrapper}>
      <div
        className={classes.section6Container}
        style={{ backgroundImage: `url("/img/about-us-img/banner-bgs.png")` }}
      >
        {/* Left Content */}
        <div className={classes.section6Content}>
          <h2 className={classes.section6Title}>
            Start Your PSP Billing at 6% - Scalable & Affordable
          </h2>
          <p className={classes.section6Description}>
            Competitive Pricing, Scalable Plans, Trusted by Businesses
          </p>
          <Link to="/contact-us">
            <button className={classes.section6Button}>Let's Begin!</button>
          </Link>
        </div>

        {/* Right Image */}
        <div className={classes.section6ImageWrapper}>
          <img
            src="/img/about-us-img/banner-doctor.png"
            alt="Doctor with laptop"
            className={classes.section6Image}
          />

          {/* Floating Stats Cards */}
          <div className={`${classes.section6StatCard} ${classes.stat1}`}>
            <FaFileInvoiceDollar className={classes.section6StatIcon} />
            <div>
              98% <br /> Clean Claims Rate
            </div>
          </div>

          <div
            className={`${classes.section6StatCard} ${classes.stat2} ${classes.blue}`}
          >
            <FaDollarSign className={classes.section6StatIcon} />
            <div>
              Revenue Collected: <br /> 500+ Millions
            </div>
          </div>

          <div className={`${classes.section6StatCard} ${classes.stat3}`}>
            <FaRegClock className={classes.section6StatIcon} />
            <div>
              14 Days Average <br /> Reimbursement Cycle
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
